/* eslint-disable @typescript-eslint/no-explicit-any */
import { EpkModuleApiService } from '~packages/epk-front-shared/api-client';
import { Mode, RequestMethod } from '~packages/json-api/client';
import replacePlaceholdersCustom, {
  PathParts,
} from '~packages/json-api/client/helpers/__base/replacePlaceholdersCustom';

import getConstants from '@/constants';

const { isModeDevelopment } = getConstants();

const constructorParams = {
  className: 'ReportsApiService',
  mode: isModeDevelopment ? Mode.Production : Mode.Production,
  // needInit: isModeDevelopment,
};

export interface IDataGetParts {
  ns: string;
  scope: string;
  uuid: string;
  timeStamp?: string;
}

export interface IDocGetParts {
  ns: string;
  pointCode: number | bigint | string;
}

export interface IPrintParts {
  ns: string;
  uuid: string;
}

export interface IPrintPartsEpk {
  ns: string;
  epk: number;
}

export interface IUpdateParts {
  ns: string;
  uuid: string;
}

export default class ReportsApiService extends EpkModuleApiService {
  printPath;
  printPathFiveYears;

  constructor() {
    super(constructorParams);
    this.basePath = this.basePath.replace('reports', '');
    this.printPath = `{ns}/prints/v1/{uuid}`;
    this.printPathFiveYears = `{ns}/prints/v1/five_years/{epk}`;
  }

  async dataGet(
    { ns, scope, uuid, timeStamp }: IDataGetParts,
    params?: Record<string, unknown>
  ) {
    let url = `${ns}/data/${scope}/${uuid}`;

    if (!!timeStamp && ns === 'epk-reports') url += `/${timeStamp}`;

    return await this._sendRequest(url, params, undefined, {
      method: 'dataGet',
    });
  }

  async docGet(
    { ns, pointCode }: IDocGetParts,
    params?: Record<string, unknown>
  ) {
    return await this._sendRequest(
      `${ns}/doc/${pointCode}`,
      params,
      undefined,
      { method: 'docGet' }
    );
  }

  async print(parts: IPrintParts, params?: Record<string, unknown>) {
    return await this._sendRequest(
      replacePlaceholdersCustom(this.printPath, parts as unknown as PathParts),
      params,
      { method: RequestMethod.POST },
      { method: 'print' }
    );
  }

  async printFiveYears(
    parts: IPrintPartsEpk,
    params?: Record<string, unknown>
  ) {
    return await this._sendRequest(
      replacePlaceholdersCustom(
        this.printPathFiveYears,
        parts as unknown as PathParts
      ),
      params,
      { method: RequestMethod.POST },
      { method: 'printFiveYears' }
    );
  }

  async update({ ns, uuid }: IUpdateParts, payload: any) {
    return await this._sendRequest(
      `${ns}/data/${uuid}`,
      undefined,
      { body: JSON.stringify(payload), method: RequestMethod.PUT },
      { method: 'printFiveYears' }
    );
  }
}
